import { ReactComponent as UserSvg } from './user.svg';
import { ReactComponent as TrashSvg } from './trash.svg';
import { ReactComponent as LogoSvg } from './logo.svg';
import { ReactComponent as SearchSvg } from './search.svg';
import { ReactComponent as MenuSvg } from './menu.svg';
import { ReactComponent as ArrowRightSvg } from './arrowRight.svg';
import { ReactComponent as HelpSvg } from './help.svg';
import { ReactComponent as EditSvg } from './edit.svg';
import { ReactComponent as ExitSvg } from './exit.svg';
import { ReactComponent as SpinnerSvg } from './spinner.svg';

export interface IIconProps {
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  dataTestId?: string;
}

const createIcon =
  (svg: JSX.Element, iconClassName: string) =>
  // eslint-disable-next-line react/display-name
  ({ className, dataTestId, onClick }: IIconProps) => {
    const classNames = `svg-icon-holder ${iconClassName} ${className || ''}`;
    return (
      <div className={classNames} onClick={onClick} data-testid={dataTestId ?? iconClassName} role='presentation'>
        {svg}
      </div>
    );
  };

export const UserIcon = createIcon(<UserSvg />, 'user-icon');

export const TrashIcon = createIcon(<TrashSvg />, 'trash-icon');

export const LogoIcon = createIcon(<LogoSvg />, 'logo-icon');

export const SearchIcon = createIcon(<SearchSvg />, 'search-icon');

export const MenuIcon = createIcon(<MenuSvg />, 'menu-icon');

export const ArrowIconRight = createIcon(<ArrowRightSvg />, 'arrow-icon-right');

export const HelpIcon = createIcon(<HelpSvg />, 'help-icon');

export const EditIcon = createIcon(<EditSvg />, 'edit-icon');

export const ExitIcon = createIcon(<ExitSvg />, 'exit-icon');

export const SpinnerIcon = createIcon(<SpinnerSvg />, 'spinner');
